import { SAColumns } from '@saux/design-system-react';
import React, { useEffect, useState } from 'react'
import styled from 'styled-components';
import CheckBox from '../checkBox/CheckBox';
import { getDashboardConversationTime } from '../../utils/utilities';

const Record = styled.li`
    display: flex;
    min-height: 50px;
    border-bottom: 1px solid #E8EBF0;
    padding: 10px;
    margin: 10px;
    .claim-info{
        width: 100%;
        margin: 0 30px;
        .time{
            font-size: 10px;
            color: #979797;
            margin-bottom: 5px;
        }
        .claim-details{
            display: flex;
            justify-content: space-between;
            font-size: 12px;
            .name{
                    text-overflow: ellipsis;
                    white-space:nowrap;
                    overflow: hidden;
                    max-width: 150px;
            }
        }
    }
`;

export default function DashBoardConversationItem(props: any) {
    const [isChecked, setChecked] = useState(false);

    useEffect(() => {
        let value = (props.selectedConversations && props.selectedConversations[props.index]) ? true : false
        setChecked(value)
    }, [props.selectedConversations])

    const handleChecked = (value: boolean) => {
        setChecked(value)
        props.handleSelectedConversations(props.index, value);
    }

    return (
        <Record data-testid="dashboard-conversation-item">
            <CheckBox id={props.conversation.conversationId} styles={{ display: "flex", paddingBottom: 14, alignItems: "center" }} isChecked={isChecked} handleChange={(value) => handleChecked(value)} />           
            <div className="claim-info">
                <div className="time">
                    {getDashboardConversationTime(props.conversation?.latestMessageTimeStamp)}
                </div>
                <SAColumns columns={{ sm: [3, 3, 3, 2, 1] }}>
                    <div className="name">
                        <b>Name:</b> {props.conversation?.customerName}
                    </div>
                    <div>
                        <b>Claim:</b> {props.conversation?.claimNumber}
                    </div>
                    <div>
                        <b>Product Type:</b> {props.conversation.productType}
                    </div>
                    
                    <div>
                        <b>Loss Date:</b> {props.conversation.lossDate}
                    </div>

                    <div>
                        <b>Status:</b> {props.conversation.claimStatus}
                    </div>

                </SAColumns>
            </div>
        </Record>
    )
}
